<template>
  <div>
    <div class="reload" @click="reloadToggle" />
    <div
      class="svg-outer svg-topLayer img-laptop img-all"
      @click="reloadToggle"
    >
      <div class="arc-1" :style="arc1_setter">
        <arc1 :animate-speed="animationSpeed" :parent-clicked="reload" />
      </div>
      <div class="arc-2" :style="arc2_setter">
        <arc2
          :stroke-color="arc2_color"
          :animate-speed="animationSpeed"
          :parent-clicked="reload"
        />
      </div>
      <div class="arc-3" :style="arc3_setter">
        <arc3
          :stroke-color="arc3_color"
          :animate-speed="animationSpeed"
          :parent-clicked="reload"
        />
      </div>
      <div
        id="circlediv"
        ref="circlediv"
        class="circle-1 top-layer"
        :style="circle_setter"
      />
    </div>
  </div>
</template>

<script lang="ts">
import { Component, Prop, Vue } from "vue-facing-decorator";
import Arc1 from "@/components/prospect/brandPattern/arc1.vue";
import Arc2 from "@/components/prospect/brandPattern/arc2.vue";
import Arc3 from "@/components/prospect/brandPattern/arc3.vue";
import $ from "jquery";
@Component({
  components: {
    arc1: Arc1,
    arc2: Arc2,
    arc3: Arc3,
  },
})
export default class BrandPattern extends Vue {
  // Data with default values
  reload = true;
  animationSpeed = process.env.VUE_APP_BRANDPATTERN_SPEED
    ? parseInt(process.env.VUE_APP_BRANDPATTERN_SPEED)
    : 1500;
  arc1_color = "#387DFF";
  arc2_color = "#FFFFFF";
  arc3_color = "#FFFFFF";
  arc1_setter: Record<string, string> = { top: "-48px", right: "0px" };
  arc2_setter: Record<string, string> = { top: "163px", left: "-15px" };
  arc3_setter: Record<string, string> = { top: "220px", right: "30px" };
  circle_setter: Record<string, string> = {
    top: "430px",
    right: "0px",
    "animation-duration": `${this.animationSpeed}ms`,
  };

  // Props
  @Prop()
  public page!: string;
  public top;

  // Created method
  created() {
    this.setChanges();
  }

  // Computed values
  get arc1Setter() {
    return this.arc1_setter;
  }
  get arc2Setter() {
    return this.arc2_setter;
  }
  get arc3Setter() {
    return this.arc3_setter;
  }
  get circleSetter() {
    return this.circle_setter;
  }

  // Methods
  setChanges() {
    if (this.page == "VERIFY") {
      this.arc1_color = "#387DFF";
      this.arc2_color = "#EEEFF0";
      this.arc3_color = "#EEEFF0";
      this.arc1_setter = { top: "-48px", right: "0px" };
      this.arc2_setter = { top: "163px", left: "-15px" };
      this.arc3_setter = { top: "220px", right: "30px" };
      this.circle_setter = {
        top: "430px",
        right: "0px",
        "animation-duration": `${this.animationSpeed}ms`,
      };
    } else if (this.page == "EMAILTHANKS") {
      this.arc1_color = "#387DFF";
      this.arc2_color = "#FFFFFF";
      this.arc3_color = "#FFFFFF";
      this.arc1_setter = { top: "-48px", right: "10px" };
      this.arc2_setter = { top: "115px", left: "0px" };
      this.arc3_setter = { bottom: "0px", right: "30px" };
      this.circle_setter = {
        top: "400px",
        right: "0px",
        "animation-duration": `${this.animationSpeed}ms`,
      };
    }
  }

  reloadToggle() {
    this.reload = !this.reload;
    $(this.$refs.circlediv as any).removeClass("top-layer");
    setTimeout(() => {
      $(this.$refs.circlediv as any).addClass("top-layer");
    }, 0);
  }
}
</script>

<style scoped>
.reload {
  width: 200%;
  height: 115%;
  position: absolute;
  left: -110%;
  top: -15%;
  z-index: 0;
}

.arc-1 {
  position: absolute;
  height: 120px;
  z-index: 1;
}

.arc-2 {
  position: absolute;
  overflow: hidden;
  width: 100px;
  height: 300px;
  z-index: 1;
}

.arc-3 {
  position: absolute;

  z-index: 1;
  width: 327px;
  height: 400px;
}

.svg-outer {
  position: absolute;
  width: 555px;
  left: 0px;
  top: v-bind(top);
  max-width: 650px;
  z-index: 0;
}

.circle-1 {
  width: 60px;
  height: 60px;

  position: absolute;
  border-radius: 60px;
}

@keyframes circle {
  from {
    opacity: 0%;
  }

  to {
    opacity: 100%;
  }
}

.circle-1.top-layer {
  animation-name: circle;
  animation-iteration-count: 1;
  animation-timing-function: linear;
  z-index: 3;
  position: absolute;
  overflow: hidden;
  background: #48a0ff;
}

@media screen and (min-width: 3840px) {
  .svg-outer {
    zoom: 1.8;
  }
  .arc-3 {
    bottom: 40% !important;
  }
}
</style>
